import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';

import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ISalesforceFieldMapping } from '../adv2-config';

export interface ISalesforcePathOptionView {
  segment: string;
  label: string;
  type?: string;
  sourceType?: string;
  associatedEntity?: string;
}

export interface ISalesforceFlyoutColumnView {
  targetObject: string;
  options: ISalesforcePathOptionView[];
  loading: boolean;
  error: string | null;
  searchTerm: string;
  selectedRelation: ISalesforcePathOptionView | null;
}

export interface ISalesforcePathBuilderPickerApi {
  getSelectedPathSegments(mappingIndex: number, fieldIndex: number): string[];
  isBuiltPathInvalid(mappingIndex: number, fieldIndex: number): boolean;
  getPathLevels(mappingIndex: number, fieldIndex: number): number[];
  getPathLevelLabel(mappingIndex: number, fieldIndex: number, level: number): string;
  getPathLevelSearchTerm(mappingIndex: number, fieldIndex: number, level: number): string;
  getSelectedPathLevelLabel(mappingIndex: number, fieldIndex: number, level: number): string;
  onPathLevelSearchChange(mappingIndex: number, fieldIndex: number, level: number, term: string): void;
  setPathLevelOpen(mappingIndex: number, fieldIndex: number, level: number, open: boolean): void;
  closePathLevel(mappingIndex: number, fieldIndex: number, level: number): void;
  isPathLevelOpen(mappingIndex: number, fieldIndex: number, level: number): boolean;
  getPathLevelDomKey(mappingIndex: number, fieldIndex: number, level: number): string;
  getFlyoutDropdownWidth(mappingIndex: number, fieldIndex: number, level: number): number;
  onFlyoutScroll(mappingIndex: number, fieldIndex: number, level: number): void;
  getFlyoutBreadcrumb(mappingIndex: number, fieldIndex: number, level: number): string;
  canFlyoutScrollLeft(mappingIndex: number, fieldIndex: number, level: number): boolean;
  canFlyoutScrollRight(mappingIndex: number, fieldIndex: number, level: number): boolean;
  scrollFlyoutColumns(mappingIndex: number, fieldIndex: number, level: number, direction: 'left' | 'right'): void;
  getFlyoutColumns(mappingIndex: number, fieldIndex: number, level: number): ISalesforceFlyoutColumnView[];
  trackByFlyoutColumn(index: number, column: ISalesforceFlyoutColumnView): string;
  onFlyoutColumnSearchChange(mappingIndex: number, fieldIndex: number, level: number, columnIndex: number, term: string): void;
  getFilteredFlyoutColumnOptions(mappingIndex: number, fieldIndex: number, level: number, columnIndex: number): ISalesforcePathOptionView[];
  trackByPathOption(index: number, option: ISalesforcePathOptionView): string;
  onFlyoutOptionHover(mappingIndex: number, fieldIndex: number, level: number, columnIndex: number, option: ISalesforcePathOptionView): void;
  onFlyoutOptionSelect(mappingIndex: number, fieldIndex: number, level: number, columnIndex: number, option: ISalesforcePathOptionView): void;
  isRelationOptionSelectedForColumn(
    mappingIndex: number,
    fieldIndex: number,
    level: number,
    columnIndex: number,
    option: ISalesforcePathOptionView
  ): boolean;
  formatPathOption(option?: ISalesforcePathOptionView): string;
  hasSelectableFlyoutOptions(mappingIndex: number, fieldIndex: number, level: number, columnIndex: number): boolean;
  isAtAssociatedEntityDepthCap(mappingIndex: number, fieldIndex: number, level: number, columnIndex: number): boolean;
  getPathLevelLoading(mappingIndex: number, fieldIndex: number, level: number): boolean;
  getPathLevelError(mappingIndex: number, fieldIndex: number, level: number): string | null;
  stepBackPath(mappingIndex: number, fieldIndex: number): void;
  canStepBackPath(mappingIndex: number, fieldIndex: number): boolean;
  clearPathPicker(mappingIndex: number, fieldIndex: number): void;
}

@Component({
  selector: 'app-salesforce-path-builder-picker',
  standalone: true,
  templateUrl: './salesforce-path-builder-picker.component.html',
  styleUrl: './salesforce-path-builder-picker.component.scss',
  imports: [FormsModule, OverlayModule],
})
export class SalesforcePathBuilderPickerComponent {
  @Input({ required: true }) mappingIndex!: number;
  @Input({ required: true }) fieldIndex!: number;
  @Input({ required: true }) field!: ISalesforceFieldMapping;
  @Input({ required: true }) api!: ISalesforcePathBuilderPickerApi;
  @Input() maxAssociatedEntityDepth = 2;
  @Input() pathDropdownPositions: ConnectedPosition[] = [];
}
